export default __webpack_public_path__ + "static/media/480_dummy2016-moebelbauer01-de.0d4b625f.png";